import {
  SET_SAVING_USER_TAG,
  SET_USER_TAGS,
  SET_USER_TAGS_LOADING,
  UPDATE_USER_TAG,
  UPDATE_USER_TAGS_ID,
} from './mutation-types'

import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
import { normalizeUserTags } from '@/lib/helpers/userTags.helpers'
const StoreRepository = RepositoryFactory.get('store')
const ProfileRepository = RepositoryFactory.get('profile')

export default {
  namespaced: true,
  state: {
    userTags: [],
    loading: false,
    savingUserTag: false,
    allTagsID: 1,
  },
  getters: {
    userTags: (state) => state.userTags,
    userTagsId: (state) => state.allTagsID,
    userTagsWithCampaigns: (state) => state.userTags.filter((tag) => Boolean(tag.campaign)),
    loading: (state) => state.loading,
    savingUserTag: (state) => state.savingUserTag,
  },
  mutations: {
    [SET_USER_TAGS]: (state, userTags) => (state.userTags = userTags),
    [SET_USER_TAGS_LOADING]: (state, loading) => (state.loading = loading),
    [UPDATE_USER_TAG]: (state, tag) => {
      const index = state.userTags.findIndex((item) => item.id === tag.id)

      if (index !== -1) {
        state.userTags = state.userTags.map((item) =>
          item.id === tag.id ? { ...item, ...tag } : item,
        )
      } else {
        state.userTags = [...state.userTags, tag]
      }
    },
    [SET_SAVING_USER_TAG]: (state, saving) => (state.savingUserTag = saving),
    [UPDATE_USER_TAGS_ID]: (state) => state.allTagsID++,
  },
  actions: {
    initUserTags({ dispatch }) {
      dispatch('fetchUserTags')
    },
    fetchUserTags({ rootState, commit }) {
      commit(SET_USER_TAGS_LOADING, true)
      StoreRepository.getUserTags(rootState.user.token, rootState.shop.shop.id).then((response) => {
        commit(SET_USER_TAGS, normalizeUserTags(response.data))
        commit(SET_USER_TAGS_LOADING, false)
      })
    },
    async createUserTag({ rootState, commit }, { name }) {
      const { data } = await StoreRepository.createUserTag(
        rootState.user.token,
        rootState.shop.shop.id,
        name,
      )

      commit(UPDATE_USER_TAG, data)
      return data
    },
    async assignUserTag({ rootState }, { profileId, tagId }) {
      await ProfileRepository.assignUserTag(rootState.user.token, profileId, tagId)
    },
    async removeUserTag({ rootState }, { profileId, tagId }) {
      await ProfileRepository.removeUserTag(rootState.user.token, profileId, tagId)
    },
  },
}
